import GalleryService from '@/services/gallery.service';

export async function editArtwork({
  formState,
  setFormError,
  navigate,
  cacheHandler,
  onArtworkEdited = null,
  userType,
}) {
  const { response, data } = await GalleryService.editArtwork(formState);

  if (!response.ok) {
    if (response.status === 400) {
      setFormError([{ element: data.error_data.element, error_code: data.error_type }]);
      return false;
    }
    setFormError([{ element: 'general', error_code: 'SERVER_ERROR' }]);
    return false;
  }

  /* -------------------------------------------------- */
  /* 1) INVALIDAMOS  ——— sea crítico o no               */
  /* -------------------------------------------------- */
  cacheHandler.triggerAction('EDIT_ARTWORK');          //  ←  💥 clave
  /* …o, si prefieres mantener la clave por id,        */
  /* stateHandler.set(`${userId}_REFRESH`, {});        */
  /* -------------------------------------------------- */

  /* 2) Ramas de navegación */
  if (data.is_critical) {
    const redirectTo = userType === 'artist' ? '/profile'
      : '/inventory/pending';
    return navigate(redirectTo, { replace: true });
  }

  /* 3) No crítico: actualizamos caché puntual y back */
  cacheHandler.storeInCache(
    `artwork_${data.artwork.slug}`,
    { totalDocs: 1, data: [data.artwork] },
    { invalidateWhen: ['EDIT_ARTWORK', 'DELETE_ARTWORK', 'BUY_ARTWORK'] }
  );
  if (onArtworkEdited) onArtworkEdited();
  return navigate(`/artwork/${data.artwork.slug}`, { replace: true });
}
